import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import toast, { Toaster } from 'react-hot-toast';
import aavtar from '../../assets/images/aavtar.png';
import SignIn from '../SignInComponent/SignIn';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../../assets/images/Ghoomoworld-black-logo-1.png';
import './../Header/Header.css';

function HeaderComponent(props) {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState('Login')
    const [fullName, setFullName] = useState('')
    const [mobileNo, setMobileNo] = useState('')
    const [confirmPass, setConfirmPass] = useState('')
    const [email, setEmail] = useState('')
    const [role, setRole] = useState('User')
    const [fullNameError, setFullNameError] = useState('')
    const [mobileNoError, setMobileNoError] = useState('')
    const [confirmPassError, setConfirmPassError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [userName, setUserName] = useState('')
    const [userNameError, setUserNameError] = useState('')
    const [password, setPassword] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [userDetails, setUserDetails] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isModelSign, setIsModelSign] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (props?.userDetails) {
            setUserDetails(props.userDetails);
            setIsLoggedIn(true);
        }
    }, [props?.userDetails])

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = JSON.parse(token);
                setUserDetails(decoded);
                setIsLoggedIn(true);
            } catch (error) {
                // console.error('Error parsing token:', error);
                localStorage.removeItem('token'); // Remove invalid token
            }
        }
    }, []);

    const handleSearch = () => {
        navigate('/search')
    }

    const isSearchPage = location.pathname === '/search';

    const handleOpen = () => {
        // setOpen(true);
        setIsModelSign(true)

        setValue('Login')
    }

    const handleClose = (data) => {
        if (!data) {
            setIsModelSign(false);
        }
        handleClearForm()
        setValue('Login')
    };

    const handleClearForm = () => {
        setUserName('')
        setUserNameError('')
        setPassword('')
        setPasswordError('')
        setFullName('')
        setFullNameError('')
        setMobileNo('')
        setMobileNoError('')
        setEmail('')
        setEmailError('')
        setConfirmPass('')
        setConfirmPassError('')
    }


    const onSignInUser = (data) => {
        setUserDetails(data);
        setIsLoggedIn(true)
    }

    const handleLogout = () => {
        localStorage.removeItem('token');
        setUserDetails(null);
        setIsLoggedIn(false);
        toast.success('Logged out successfully!');
        navigate('/home')
    }
    return (
        <>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
            <header className="wo-header d-none d-md-flex align-items-center justify-content-between">
                {/* Left: logo + search grouped together like WanderOn */}
                <div className="wo-header-left d-flex align-items-center">
                    <Link className="navbar-brand logo-cl" to="/" aria-label="Home">
                        <img src={logo} alt="Ghoomo World Logo" className="img-fluid logo-img" />
                    </Link>
                    {!isSearchPage && (
                        <Link className="wo-search-pill text-decoration-none" to="/search" onClick={handleSearch}>
                            <span className="wo-search-text">Where do you want to go?</span>
                            <i className="bi bi-search wo-search-icon"></i>
                        </Link>
                    )}
                </div>

                {/* Right: nav links + phone */}
                <div className="d-flex align-items-center wo-header-right">
                    <nav aria-label="Primary">
                        <ul className="wo-nav-list list-unstyled d-flex align-items-center mb-0">
                            <li className="wo-nav-item">
                                <Link className="links" to="/ladakh-with-cherry">
                                    <span> Himachal Beyond Hills</span>
                                </Link>
                            </li>
                            <li className="wo-nav-item">
                                <Link className="links" to="/upcoming-trips">
                                    <span>Upcoming Trips</span>
                                    <i className="bi bi-calendar3 wo-nav-icon"></i>
                                </Link>
                            </li>
                            {/* <li className="wo-nav-item">
                                <Link className="links" to="/corporate-tours">
                                    <span>Corporate Tours</span>
                                </Link>
                            </li> */}
                            <li className="wo-nav-item">
                                <Link className="links" to="/blogs">
                                    <span>Blogs</span>
                                </Link>
                            </li>
                            <li className="wo-nav-item">
                                <Link className="links" to="/about-us">
                                    <span>About Us</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>

                    {/* {isLoggedIn ? (
                        <div className="d-flex flex-row align-items-center">
                            <span className="me-2" style={{ fontSize: '14px', fontWeight: '500' }}>
                                {userDetails?.userName}
                            </span>
                            <NavDropdown className='aavtar-dropdown'
                                title={
                                    <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                        <img
                                            className='aavtar-img'
                                            src={aavtar}
                                            alt="User Avatar"
                                            style={{ height: '30px', width: '30px', cursor: 'pointer' }}
                                        />
                                    </div>
                                }
                            >
                                <NavDropdown.Item as={Link} to={'/profile'}>Profile</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={'/history'}>History</NavDropdown.Item>
                                <NavDropdown.Item onClick={handleLogout}>Log Out</NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    ) : (
                        <button
                            className="btn ms-auto"
                            onClick={handleOpen}
                            style={{boxShadow:'none'}}
                        >
                            <span className="btn-label me-1">
                                <i className="bi bi-person me-1"></i>|
                            </span>
                            Login
                        </button>
                    )} */}

                    <div class="phone-badge">
                        <a href="tel:+919090403075" class="phone-link">
                            <svg class="phone-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                            </svg>
                            <span>+91-9699214268</span>
                        </a>
                    </div>
                </div>
            </header>

            {/* Mobile header — unchanged from original */}
            <div className="container-fluid header-container-fluid d-md-none">
                <div className="row d-flex align-items-center header-height justify-content-between">
                    <div className="d-flex d-md-none justify-content-between align-items-center">
                        <div className="d-flex justify-content-start">
                            <Link className="navbar-brand logo-cl" to="/">
                                <img src={logo} alt="Ghoomo World Logo" className="img-fluid logo-img" />
                            </Link>
                        </div>
                        <div className="d-flex justify-content-end ">
                            {isLoggedIn ? (
                                <div className="d-flex flex-row align-items-center">
                                    {/* In future client want username for mobile view also  */}
                                    {/* <span className="me-2" style={{ fontSize: '14px', fontWeight: '500' }}>
                                        {userDetails?.userName}
                                    </span> */}
                                    <NavDropdown className='aavtar-dropdown'
                                        title={
                                            <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'end' }}>
                                                <img
                                                    className='aavtar-img'
                                                    src={aavtar}
                                                    alt="User Avatar"
                                                    style={{ height: '30px', width: '30px', cursor: 'pointer' }}
                                                />
                                            </div>
                                        }
                                    >
                                        <NavDropdown.Item as={Link} to={'/profile'}>Profile</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to={'/history'}>History</NavDropdown.Item>
                                        <NavDropdown.Item onClick={handleLogout}>Log Out</NavDropdown.Item>
                                    </NavDropdown>
                                </div>
                            ) : (
                                <button
                                    className="btn ms-auto"
                                    onClick={handleOpen}
                                    style={{ boxShadow: 'none' }}
                                >
                                    <span className="btn-label me-1">
                                        <i className="bi bi-person me-1"></i>|
                                    </span>
                                    Login
                                </button>
                            )}

                            <div className="toggle-btn-container d-flex align-items-center">
                                <button
                                    className="toggle-btn"
                                    type="button"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#mobileSidebar"
                                    aria-controls="mobileSidebar"
                                >
                                    <i className="fas fa-bars"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                isModelSign && (
                    <div>
                        <SignIn isModelSign={isModelSign} closePopup={handleClose} userDetais={onSignInUser}></SignIn>
                    </div>
                )
            }
        </>
    )
}

export default HeaderComponent;